var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns form-info-panel" }, [
    _c(
      "div",
      {
        class: [
          "column",
          _vm.fieldsColumn,
          { "field-column": !_vm.fieldsColumn },
        ],
      },
      [_vm._t("fields")],
      2
    ),
    _vm.hasInfoSlot
      ? _c("div", { class: ["column", _vm.infoColumn] }, [
          _c(
            "div",
            { staticClass: "sidebar" },
            [
              _c(
                "app-tip-text",
                { staticClass: "content" },
                [_vm._t("info")],
                2
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }